module.exports = __webpack_public_path__ + "img/feature2.8a5e518.png";